import {selectFieldFilterSx} from '@hconnect/common/styles'
import {MenuItem, TextField} from '@mui/material'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE, ALL_FREQUENCIES} from '../consts'

type JtbdFrequencyDropdownSelectorProps = {
  selectedFrequency: string
  onSelectedFrequencyChanged: (frequency: string) => void
  frequencies: string[]
}

export const JtbdFrequencyDropdownSelector = ({
  selectedFrequency,
  onSelectedFrequencyChanged,
  frequencies
}: JtbdFrequencyDropdownSelectorProps) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  const sortedFrequencies = [...frequencies].sort((a, b) => a.localeCompare(b))

  return (
    <TextField
      variant="filled"
      sx={selectFieldFilterSx}
      label={t('jobsToBeDone.label.frequency')}
      data-test-id="jtbd-frequency-dropdown"
      value={selectedFrequency}
      onChange={(event) => {
        onSelectedFrequencyChanged(event.target.value)
      }}
      select
    >
      <MenuItem value={ALL_FREQUENCIES} key={ALL_FREQUENCIES} data-test-id="frequency-all">
        {t('jobsToBeDone.label.allFrequencies')}
      </MenuItem>
      {sortedFrequencies.map((frequency) => (
        <MenuItem value={frequency} key={frequency} data-test-id={`frequency-${frequency}`}>
          {frequency}
        </MenuItem>
      ))}
    </TextField>
  )
}
